import { render, staticRenderFns } from "./HotNew.vue?vue&type=template&id=e27623ca&scoped=true&"
import script from "./HotNew.vue?vue&type=script&lang=js&"
export * from "./HotNew.vue?vue&type=script&lang=js&"
import style0 from "./HotNew.vue?vue&type=style&index=0&id=e27623ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27623ca",
  null
  
)

export default component.exports